import './styles.scoped.css'
import {useEffect, useState} from 'react'
import {Typography, Button, Modal, TextField, Avatar, Chip, Autocomplete, IconButton} from '@mui/material'
import {Close} from '@mui/icons-material'
import {useGlobalStates} from '../../../../contexts/GlobalStatesContext'
import {clientApi} from '../../../../services'
import {getInitials, getColorFromName, parseError} from '../../../../utils/helpers'
import {useParams} from 'react-router-dom'
import {useMobile} from '../../../../hooks'

export default ({open, setOpen, data, loadData, client, caregivers}) => {
    const {setLoading, setMessageBox, branchId} = useGlobalStates()
    const {clientId} = useParams()
    const {mobile} = useMobile()
    const [services, setServices] = useState([])
    const [selectedServices, setSelectedServices] = useState([])

    useEffect(() => {
        const caregiver = caregivers?.find(item => item?.id == data?.caregiver_id)
        if (caregiver?.services) {
            const availableServices = caregiver?.services?.filter(item =>
                (client?.services ?? []).some(item2 => item2.service_id === item.service_id),
            )
            setServices(availableServices?.map(item => ({...item, key: item?.service_id, value: item?.service_name})))
        }
    }, [open, data])

    useEffect(() => {
        if (data?.services) {
            selectedServices.length = 0
            data?.services?.forEach(item => {
                selectedServices.push(services.find(s => s.key == item?.service_id))
            })
        }
    }, [services])

    const submit = () => {
        setLoading(true)
        clientApi
            .updateClientCaregiver(branchId, clientId, data?.id, {
                service_ids: selectedServices?.map(s => s.key),
            })
            .then(() => {
                setLoading(false)
                setOpen(false)
                setMessageBox({
                    status: 'success',
                    title: `Assigned Service from ${data?.caregiver?.first_name} is Updated`,
                    description: `The changes of assigned service from ${data?.caregiver?.first_name} to ${data?.caregiver?.first_name} has updated.`,
                })
                loadData()
            })
            .catch(error => {
                setLoading(false)
                setOpen(false)
                const {title, description} = parseError(error)
                if (description) {
                    setMessageBox({status: 'error', title, description})
                }
            })
    }

    return (
        <Modal open={open}>
            <div className="container">
                <div className="content">
                    {mobile ? (
                        <>
                            <div className="header">
                                <Typography variant="h6" color="text.primary">
                                    Update Assigned Service from {data?.caregiver?.first_name}
                                </Typography>
                                <IconButton onClick={() => setOpen(false)}>
                                    <Close />
                                </IconButton>
                            </div>
                            <div className="actions">
                                <Button variant="outlined" fullWidth onClick={() => setOpen(false)}>
                                    Cancel
                                </Button>
                                <Button variant="contained" fullWidth onClick={submit}>
                                    Save Changes
                                </Button>
                            </div>
                            <br />
                            <br />
                            <br />
                            <br />
                        </>
                    ) : (
                        <Typography variant="h6" color="text.primary" className="title">
                            Update Assigned Service from {data?.caregiver?.first_name}
                        </Typography>
                    )}
                    <br />
                    <div className="people-card">
                        {data?.caregiver?.avatar_url ? (
                            <Avatar src={data?.caregiver?.avatar_url} style={{width: 40, height: 40}} />
                        ) : (
                            <Avatar
                                style={{
                                    backgroundColor: getColorFromName(data?.caregiver?.first_name + ' ' + data?.caregiver?.last_name),
                                    width: 40,
                                    height: 40,
                                    fontSize: 16,
                                }}>
                                {getInitials(data?.caregiver?.first_name + ' ' + data?.caregiver?.last_name)}
                            </Avatar>
                        )}
                        <Typography variant="h7" color="text.primary">
                            {data?.caregiver?.first_name + ' ' + data?.caregiver?.last_name}
                        </Typography>
                    </div>
                    <br />
                    <Typography variant="inputLabel" color="text.secondary">
                        Service
                    </Typography>
                    <Autocomplete
                        multiple
                        options={services}
                        value={selectedServices}
                        onChange={(e, newVal) => setSelectedServices(newVal)}
                        isOptionEqualToValue={(opt, val) => opt.key === val.key}
                        getOptionLabel={opt => opt.value}
                        renderInput={params => <TextField {...params} placeholder="Select service" />}
                        slotProps={{chip: {sx: {display: 'none'}}}}
                    />
                    <div className="services">
                        {selectedServices.map(item => (
                            <Chip
                                key={item.key}
                                label={item.value}
                                onDelete={() => setSelectedServices(prev => prev.filter(p => p.key !== item.key))}
                                variant="contained"
                                size="medium"
                            />
                        ))}
                    </div>
                    <br />
                    {mobile ? (
                        <>
                            <br />
                            <br />
                            <br />
                            <br />
                        </>
                    ) : (
                        <div className="actions">
                            <Button variant="outlined" fullWidth onClick={() => setOpen(false)}>
                                Cancel
                            </Button>
                            <Button variant="contained" fullWidth onClick={submit}>
                                Save Changes
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        </Modal>
    )
}
